import React, { useEffect, useState } from 'react';
import styles from './FacultyPage.module.scss';
import { useNavigate } from 'react-router-dom';
import TopHeader from '../../Molecules/SpeechAndTestimonials/TopHeader';
import TablePagination from '../../Molecules/Pagination/TablePagination';
import { useFetchTeams } from '../../../Hooks/Teams';
import MemberCard from '../../Molecules/Faculty/MemberCard';
import Loader from '../../Molecules/Loader/Loader';
import { debounce } from 'lodash';
import NoDataComponent from '../../Molecules/Custom/NoDataComponent/NoDataComponent';

const FacultyPage = () => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);

  const {
    data,
    refetch,
    isLoading: isLoadingTeams,
  } = useFetchTeams(page, pageSize, search);

  const itemsPerPage = data?.data?.pageSize;
  const totalItems = data?.data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    handleSearch();
  }, [search]);

  const handleSearch = debounce(() => {
    refetch();
  }, 300);
  useEffect(() => {
    refetch();
  }, [pageSize, page]);

  const handleNavigate = (e) => {
    e.preventDefault();
    navigate('/home/add-faculty');
  };
  if (isLoadingTeams) {
    return <Loader />;
  }
  return (
    <div>
      <TopHeader
        search={search}
        setSearch={setSearch}
        handleNewClick={handleNavigate}
        buttonTitle='إضافة جديدة'
      />
      <div className={styles['table-container']}>
        {data?.data?.items?.length > 0 ? (
          <div className={styles['major-box-grid']}>
            {data?.data?.items
              ?.sort((a, b) => a.facultyId - b.facultyId)
              ?.map((x, i) => (
                <MemberCard data={x} refetch={refetch} key={i} />
              ))}
          </div>
        ) : (
          <NoDataComponent />
        )}

        <TablePagination
          totalPages={totalPages}
          page={page}
          setPage={setPage}
          itemsPerPage={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default FacultyPage;
